import { P, PAL, Particles, Rng, fit, type FxMeta } from "pixelfx";

/** Брызги крови на попадании: капли-искры по ходу удара, падают, отскакивают и гаснут. Эффект в формате pixelfx. */
export const meta: FxMeta & { options: Record<string, unknown> } = {
  name: "Blood burst",
  duration: 1.4,
  loop: false,
  fps: 30,
  size: [96, 64],
  origin: [48, 48],
  options: { seed: 1, count: 22, flip: false, floor: 16 },
};

interface BurstOptions {
  seed: number;
  count: number;
  flip: boolean;
  floor: number;
}

export function create(options: BurstOptions): { update(dt: number): void; draw(painter: unknown): void } {
  const random = new Rng(options.seed);
  const ramp = fit(PAL.blood ?? ["#a01824"], 5);
  const particles = new Particles({ rng: random, ground: () => options.floor, sparks: ramp.slice(2) });
  const direction = options.flip ? -1 : 1;
  for (let index = 0; index < options.count; index++) {
    const speed = random.range(180, 520);
    const spread = random.range(-0.9, 0.5);
    particles.spawn(
      P.SPARK ?? 0,
      0,
      0,
      direction * speed * Math.cos(spread),
      speed * Math.sin(spread) - 40,
      random.range(0.3, 0.8),
    );
  }
  for (let index = 0; index < 6; index++) {
    particles.spawn(
      P.GRIT ?? 0,
      0,
      0,
      direction * random.range(20, 90),
      random.range(-140, -40),
      random.range(0.6, 1.2),
      ramp[3],
    );
  }
  return {
    update(dt: number): void {
      particles.update(dt);
    },
    draw(painter: unknown): void {
      particles.draw(painter);
    },
  };
}
